<template>
  <ul :class="classes" :style="styles">
    <slot></slot>
  </ul>
</template>
<script>
import { PREFIX_MENU_CLASS } from './constants'
import { findComponentsDownward } from '../../utils/assist'
import Emitter from '../../mixins/emitter'

export default {
  name: 'TMenu',
  mixins: [Emitter],
  props: {
    mode: {
      type: String,
      validator(value) {
        return ['horizontal', 'vertical'].includes(value)
      },
      default: 'vertical'
    },
    type: {
      type: String,
      validator(value) {
        return ['light', 'dark', 'ghost'].includes(value)
      },
      default: 'light'
    },
    openPosition: {
      type: String,
      validator(value) {
        return ['right', 'down'].includes(value)
      },
      default: 'down'
    },
    activeName: {
      type: [String, Number],
      default: ''
    },
    openNames: {
      type: Array,
      default() {
        return []
      }
    },
    accordion: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      currentActiveName: '',
      currentOpenNames: [],
      onlyOnce: false
    }
  },
  computed: {
    classes() {
      let type = this.type
      if (this.mode === 'vertical' && this.type === 'primary') type = 'light'

      return [
        `${PREFIX_MENU_CLASS}`,
        `${PREFIX_MENU_CLASS}--${type}`,
        {
          [`${PREFIX_MENU_CLASS}--${this.mode}`]: this.mode
        }
      ]
    },
    styles() {
      let style = {}
      if (this.mode === 'vertical') style.width = this.width
      return style
    }
  },
  watch: {
    openNames(val) {
      this.$_updateOpenNames(val.concat())
      // this.onlyOnce = true
    },
    activeName(val) {
      this.$_updateActiveName(val)
    },
    openPosition(newval, oldVal) {
      if (this.mode === 'horizontal') return
      if (oldVal === 'right' && newval === 'down') {
        this.$_openSubMenus(this.currentOpenNames)
      } else {
        // 只有手风琴模式才能使用openNames
        this.$_updateOpenNames([])
      }
      this.$_updateActiveName(this.currentActiveName)
    }
  },
  mounted() {
    this.$_updateActiveName(this.activeName)
    this.$_updateOpenNames(this.openNames.concat())
    this.$on('menu-item-select', name => {
      this.$_updateActiveName(name)
      this.$emit('update:activeName', name)
      this.$emit('on-select', name)
    })
    this.$on('submenu-open', name => {
      let names = name.submenus
      if (this.accordion === true) {
        this.$emit('update:openNames', names)
        this.currentOpenNames = names
      } else {
        this.currentOpenNames = [...this.currentOpenNames, ...names]
      }
      if (this.onlyOnce === false) {
        this.$_updateOpenNames(this.currentOpenNames)
      } else {
        this.onlyOnce = false
      }
    })
    this.$on('submenu-close', name => {
      let names = this.currentOpenNames.filter((item) => {
        return item !== name
      })
      if (this.accordion === true) {
        this.$emit('update:openNames', names)
      }
      if (this.onlyOnce === false) {
        this.$_updateOpenNames(names)
      } else {
        this.onlyOnce = false
      }
    })
  },
  methods: {
    $_updateActiveName(newActiveName) {
      this.currentActiveName = newActiveName
      this.$nextTick(() => {
        this.broadcast('TSubmenu', 'on-update-active-name', false)
        this.broadcast(
          'MenuItem',
          'on-update-active-name',
          (this.currentActiveName !== undefined ? this.currentActiveName : -1)
        )
      })
    },
    updateOpenKeys(name) {
      const index = this.currentOpenNames.indexOf(name)
      if (index > -1) {
        this.currentOpenNames.splice(index, 1)
      } else {
        this.currentOpenNames.push(name)
      }
      this.$emit('on-open-change', [name])
    },
    arrayIsEqual(arr1, arr2) {
      return arr1.sort().join() === arr2.sort().join()
    },
    $_openSubMenus(openNames) {
      const items = findComponentsDownward(this, 'TSubmenu')
      if (items.length) {
        if (openNames.length > 0) {
          items.forEach(item => {
            if (openNames.indexOf(item.name) > -1) {
              item.opened = true
            } else {
              item.opened = false
            }
          })
        } else {
          items.forEach(item => {
            item.opened = false
          })
        }
      }
    },
    $_updateOpenNames(openNames) {
      // if (this.arrayIsEqual(this.currentOpenNames, openNames) === false) {
      this.currentOpenNames = openNames
      this.$_openSubMenus(openNames)
      this.$emit('on-open-change', openNames.concat())
      // }
    }
  }
}
</script>



// WEBPACK FOOTER //
// menu.vue?7960f7b2